import { RecordProxy } from "relay-runtime";

import { logger } from "@util/logger.util";

export enum RecordProxyType {
  Record,
  Records,
  Literal,
}

export const { Record, Records, Literal } = RecordProxyType;

export interface RecordProxySchemaItem {
  type: RecordProxyType.Record | RecordProxyType.Records;
  schema: { [key: string]: RecordProxyType.Literal | RecordProxySchemaItem };
}

export type RecordProxySchema = { [key: string]: RecordProxyType.Literal | RecordProxySchemaItem };

export const recordProxyToObject = (
  schema: RecordProxySchema,
  recordProxy: RecordProxy | null,
): Object => {
  const obj: { [key: string]: any } = {};

  if (!recordProxy) {
    return obj;
  }
  Object.keys(schema).forEach((key) => {
    if (schema[key] === Literal) {
      obj[key] = recordProxy.getValue(key);
    } else {
      const { type, schema: rSchema } = schema[key] as RecordProxySchemaItem;
      switch (type) {
        case Record:
          obj[key] = recordProxyToObject(rSchema, recordProxy.getLinkedRecord(key));
          break;
        case Records:
          obj[key] = (recordProxy.getLinkedRecords(key) || []).map((lr) =>
            recordProxyToObject(rSchema, lr),
          );
          break;
        default:
          logger.warn(`${type} RecordProxyType cannot have a schema`);
      }
    }
  });

  return obj;
};
